<script>
import AMapLoader from "@amap/amap-jsapi-loader";
import _ from "lodash";
import { debounce } from "@/util/util.js";

const search_site = "83bd8ecea2b353123be1e29581d77ce3";
const admin_show_map = "66c26f2efda69209025818490d05ed31";

export default {
  data() {
    return {
      debounce,
      mapContainer: `container` + new Date().getTime(),
      map: null,
      _AMap: null,
      position_marker: null,
      current_address_id: "",
      search_address_config: {
        keywords: "",
        result_json: [],
      },
    };
  },
  computed: {
    current_address_json() {
      return this.search_address_config.result_json.find(
        (item) => item.id === this.current_address_id
      );
    },

  },
  methods: {
    remoteMethod(str){
      this.search_address_config.keywords = str;
        let url = "https://restapi.amap.com/v3/assistant/inputtips?";
        url += `key=${search_site}&keywords=${this.search_address_config.keywords}`;
        this.sendRequest(url, (data) => {
          this.search_address_config.result_json = data;
        });
    },
    sendRequest(url, callback = () => {}) {
      let ajax = new XMLHttpRequest();
      ajax.open("get", url);
      //步骤三:发送请求
      ajax.send();
      //步骤四:注册事件 onreadystatechange 状态改变就会调用
      ajax.onreadystatechange = function () {
        if (ajax.readyState == 4 && ajax.status == 200) {
          //步骤五 如果能够进到这个判断 说明 数据 完美的回来了,并且请求的页面是存在的
          callback(JSON.parse(ajax.responseText).tips);
        }
      };
    },
    positionMap() {
      if (this.current_address_id) {
        let lngLat = this.current_address_json.location.split(",");
        this.map.setZoomAndCenter(15, [
          parseFloat(lngLat[0]),
          parseFloat(lngLat[1]),
        ]);
        // 清除之前的标记
        if (this.position_marker) this.map.remove(this.position_marker);
        // 添加新的标记
        this.position_marker = this.createTag([
          parseFloat(lngLat[0]),
          parseFloat(lngLat[1]),
        ]);
        this.map.add(this.position_marker);
      }
    },
    createTag(
      lngLat,
      icon = "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png"
    ) {
      let marker = new AMap.Marker({
        position: new AMap.LngLat(lngLat[0], lngLat[1]),
        offset: new AMap.Pixel(-10, -31),
        icon,
      });
      return marker;
    },
  },
  mounted() {
    AMapLoader.load({
      key: admin_show_map, // 申请好的Web端开发者Key，首次调用 load 时必填
      version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
      plugins: [],
    })
      .then((AMap) => {
        this._AMap = AMap;
        this.map = new AMap.Map(this.mapContainer, {
          // 设置地图容器id
          viewMode: "3D", // 是否为3D地图模式
          zoom: 11, // 初始化地图级别
          center: [116.397428, 39.90923], // 初始化地图中心点位置
        });
      })
      .catch((e) => {
       
      });
  },
  beforeUnmount() {
    this.map?.destroy();
  },
};
</script>

<template>
  <div>
    <div class="search_box">
      <div class="title">地址信息:</div>
      <el-select
        v-model="current_address_id"
        filterable
        remote
        placeholder="请输入"
        :remote-method="debounce(remoteMethod, 300)"
        style="width: 240px"
        @change="positionMap"
      >
        <el-option
          v-for="(item,idnex) in search_address_config.result_json"
          :key="item.id+idnex+new Date().getTime()"
          :label="item.district + item.name"
          :value="item.id"
        />
      </el-select>
    </div>
    <div :id="mapContainer" class="container"></div>
  </div>
</template>

<style lang="less" scoped>
.search_box {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  .title {
    font-size: 16px;
    margin-right: 16px;
  }
}
.container {
  width: 100%;
  height: 600px;
}
</style>
